
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

    export default {

        name: 'FundData',

        mixins: [ privacyModeTextFormatterMixin, ],

        props: {
            share: Object
        },

        computed: {
            showSustainability() {
                return this.share?.fund.msciEsgFundRating
                    || this.share?.fund.msciWeightedAvgCarbonIntensity
                    || this.share?.fund.weightedAvgMaturity
            },
            showKeyFigures() {
                return this.share?.fund.totalAssets
                    || this.share?.fund.nav
                    || this.share?.fund.aum
                    || this.share?.fund.sharesOutstanding
                    || this.share?.fund.priceBid
                    || this.share?.fund.priceAsk
                    || this.share?.fund.kgv
                    || this.share?.fund.kbv
            },
            showMasterData() {
                return this.share?.fund.company
                    || this.share?.fund.type
                    || this.share?.fund.name
                    || this.share?.fund.referenceIndex
                    || this.share?.fund.assetClass
                    || this.share?.fund.assetSubclass
                    || this.share?.fund.currency
                    || this.share?.fund.ter
                    || this.share?.fund.location
                    || this.share?.fund.region
                    || this.share?.fund.benchmarkIndex
                    || this.share?.fund.category
                    || this.share?.fund.distributionType
                    || this.share?.fund.dividendInterval
                    || this.share?.fund.dateInception
                    || this.share?.fund.market
                    || this.share?.fund.strategy
                    || this.share?.fund.riskIndicator
                    || this.share?.fund.morningstarRating
            },
        },

        data() {
            return {
                format: new FormatterService({
                    currency: 'EUR'
                }),
                shareDetails: [
                    {name: 'Wertpapierart', key: 'type'},
                    {name: 'Name', key: 'name'},
                    {name: 'Währung', key: 'currency'},
                    {name: 'Anlageschwerpunkt', key: 'description'},
                    {name: 'Wertpapierklasse', key: 'assetClass'},
                    {name: 'Wertpapiersubklasse', key: 'assetSubclass'},

                    {name: 'NAV', key: 'nav'},
                    {name: 'TER', key: 'ter'},
                    {name: 'AUM', key: 'aum'},
                    {name: 'Anzahl Assets', key: 'totalAsset'},
                    {name: 'Anteile', key: 'assetsOutstanding'},
                    {name: 'Märkte', key: 'market'},
                    {name: 'Strategie', key: 'strategy'},
                    {name: 'Emittent', key: 'company'},
                    {name: 'Kategorie', key: 'category'},
                    {name: 'Investmentart', key: 'investmentStyle'},
                    {name: 'Benchmark Index', key: 'benchmarkIndex'},
                    {name: 'Dividenden Intervall', key: 'dividendInterval'},
                    {name: 'Morningstar Rating', key: 'morningstarRating'},
                ]
            }
        },
    }
